'use client'

import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { useExperiment } from 'rvbr-www/red-testing'

import removeSpecialChars from '@equifax-ui/utils/formatters/removeSpecialChars'

import { useProposalContext } from '@/context/ProposalContext'

import { useAnalytics } from '@/hooks/useAnalytics'
import { triggerTracrTrack } from '@/hooks/useTracking'

import { getSourceUrl } from '@/utils/sourceUrl'

import { DOCUMENT_LABEL } from '@/constants'

export const usePaywall = () => {
  const {
    control,
    setValue,
    watch,
    formState: { isValid }
  } = useForm({
    mode: 'onChange'
  })

  const { activateExperiment } = useExperiment('paywall')
  const { setIsPaywallOpen } = useProposalContext()
  const { getFBData, getGAData } = useAnalytics()

  useEffect(() => {
    const document = sessionStorage.getItem(DOCUMENT_LABEL)

    setValue('cnpj', document, { shouldValidate: document })
    activateExperiment()
  }, [])

  const closeModal = () => {
    sessionStorage.setItem(DOCUMENT_LABEL, watch('cnpj'))
    setIsPaywallOpen(false)
  }

  const triggerConversionEvent = async (eventName, conversionData) => {
    const facebookContext = getFBData()
    const googleContext = await getGAData()

    triggerTracrTrack('conversion', {
      conversionContext: { eventName, ...conversionData },
      googleContext: {
        action: eventName,
        clientId: googleContext.ga4_client_id,
        gaCookie: googleContext.ga4_cookie,
        gaId: ga4Id // eslint-disable-line no-undef
      },
      facebookContext: {
        actionSource: 'website',
        eventSourceUrl: await getSourceUrl(),
        fbc: facebookContext.pixel_fbc,
        fbp: facebookContext.pixel_fbp
      }
    })
  }

  const onClickWhatsapp = async () => {
    const formattedCnpj = removeSpecialChars(watch('cnpj'))

    triggerTracrTrack('softlead', { cnpj: formattedCnpj })

    await triggerConversionEvent('LeadStart')
    await triggerConversionEvent('Paywall', { value: 10 })

    closeModal()
  }

  return {
    control,
    isValid,
    onClickWhatsapp,
    closeModal
  }
}
